export default {
  namespaced: true,

  state: {
    requests: [],
    count: 0
  },

  mutations: {
    INCREMENT_REQUESTS(state, payload) {
      console.log("Adding request");
      //state.requests.push(payload);
      state.count++;
      console.log(state.count + " requests");
    },
    DECREMENT_REQUESTS(state, payload) {
      console.log("Removing request");
      //state.requests.push(payload);
      state.count--;

      if (state.count < 0) {
        state.count = 0;
      }
      console.log(state.count + " requests");
    }
  },

  actions: {
    addRequest(context) {
      context.commit("INCREMENT_REQUESTS");
    },
    removeRequest(context) {
      context.commit("DECREMENT_REQUESTS");
    }
  }
};
